import { heapEvent } from '@equipmentshare/heaper'
import OverrideWac from '../OverrideWac'

export default function getOverrideWacModal( item: any, onSuccess?: () => void ) {
	return {
		component: OverrideWac,
		componentProps: { item },
		label: 'Edit WAC',
		width: 778,
		onSuccess,
		onXClick: () => heapEvent( 'Inventory - Override WAC Modal - Click - X button', {} ),
	}
}
